module.exports = __webpack_public_path__ + "static/media/ph1.173894bb.png";